import $ from "jquery";
import LoginButton from "./modules/login-button";
import Header from "./widgets/header"
import NewHeader from "./widgets/new-header";
import Ranking from "./widgets/ranking";
import LiveHome from "./widgets/live-home";
import AccountComplete from "./widgets/account-complete";
import domEvents from './modules/dom-events'
import ComitiumGalleryManager from "./modules/comitium-gallery-manager";
import VerticalGallery from "./widgets/vertical-gallery";
import Register from "./widgets/register"
import ExtraSlider from "./widgets/extra-gallery";

new Header();
new ComitiumGalleryManager();
new NewHeader();
domEvents.init();
ExtraSlider.init();

$('[data-login-show]').each(function(){
    new LoginButton(this);
});

$('[data-id="c-ranking"]').each(function () {
    new Ranking(this);
});

$('[data-live-home-wrapper]').each(function(){
    const element = $('[data-live-home-posts]', this);
    const scoreboardElement = $('[data-live-home-scoreboard]', this);

    new LiveHome(element, scoreboardElement);
});

$('[data-account_complete-container]').each(function () {
    new AccountComplete(this);
});

new Register($('[data-id="c-subscriptions-list"]'), $('[data-id="c-subscriptions-form"]'), $('[data-id="register-render"]'));

document.addEventListener('comitium.gallery.image.displayed', function (event) {
    if (event.detail.galleryType === "vertical") {
        new VerticalGallery();
    }
});